/**
 * Composable for handling status icons and their display logic
 */
export function useStatusIcons() {
  
  function getStatusColor(status: string | undefined): string {
    if (!status) return 'grey';
    const colorMap: Record<string, string> = {
      green: 'status-green',
      yellow: 'status-yellow',
      red: 'status-red',
      gray: 'status-gray',
      notclaimed: 'status-gray',
      notapplicable: 'status-gray',
    };
    return colorMap[status] || 'grey';
  }

  function getStatusAccessibilityLabel(status: string | undefined): string {
    if (!status) return 'Status unknown';
    const labelMap: Record<string, string> = {
      green: 'Meets Expectations',
      yellow: 'Partially Meets Expectations',
      red: 'Does Not Meet Expectations',
      gray: 'Not Eligible',
      notclaimed: 'Not Claimed',
      notapplicable: 'Not Eligible',
    };
    return labelMap[status] || 'Status unknown';
  }

  function shouldShowTextStatus(status: string | undefined): boolean {
    if (!status) return true;
    return ['gray', 'notclaimed', 'notapplicable'].includes(status);
  }

  function getStatusText(status: string | undefined): string {
    if (!status || status === 'gray') return 'NE';
    if (status === 'notclaimed') return 'NC';
    if (status === 'notapplicable') return 'NE';
    return 'NE';
  }

  return {
    getStatusColor,
    getStatusAccessibilityLabel,
    shouldShowTextStatus,
    getStatusText,
  };
} 